<template>
  <dd-dashboard-header-page
      header="Takenreeks toevoegen"
  >
    <template #content>
      <CreateTaskListComponent
      ></CreateTaskListComponent>
    </template>
  </dd-dashboard-header-page>
</template>

<script>
import CreateTaskListComponent from "~/modules/task_list/components/CreateTaskListComponent.vue";
export default {
  components: {
    CreateTaskListComponent
  }
};
</script>

<style scoped></style>